<template>
  <div class="level">
    <LevelRow
      @toggle="toggleQuiz"
      :hasAccess="hasAccess"
      :contentType="contentType"
      :contentId="content ? content.id : ''"
      :status="contentStatus"
      :parentStatus="statusText"
      :title="title"
      :plansLink="plansLink"
      :isWatching="isTakingQuiz()"
      :statusText="statusText"
      :details="quizDetails"
      :progress="progress"
      @click.native="toggleQuiz"
    >
    </LevelRow>
    <div class="level__content" v-if="isTakingQuiz()">
      <div class="content__quiz">
        <MediaDelegate
          v-bind="{
            parentType: 'course',
            content: { id: content.id, type: 'quiz' },
            userCompletionStatus: contentStatus,
            contentTitle: title,
            nextMedia: nextVideo,
            canStartIssue: true,
          }"
          @is-loading="setLoader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'QuizLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    MediaDelegate,
    LevelRow,
  },
  props: {
    courseStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: false,
    },
    contentStatus: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    nextVideo: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapState({
      currentQuizId: state => state.content.currentQuizId,
    }),
    statusText() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 'Resume quiz'
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return 'Retake quiz'
      }
      return 'Start quiz'
    },
    iconClass() {
      if (this.ofType === 'custom') return ''
      return `action__${this.ofType}--icon`
    },
    contentType() {
      return CONSTANTS.CONTENT_TYPES.QUIZ
    },
    quizDetails() {
      if (!this.content) return ''
      return this.content.number_of_questions > 1
        ? [`${this.content.number_of_questions} questions`]
        : [`${this.content.number_of_questions} question`]
    },
    progress() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 50
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return 100
      }
      return 0
    },
  },
  methods: {
    async toggleQuiz() {
      if (this.hasAccess && !this.isLoading) {
        this.isLoading = true
        const { currentQuizId, content } = this
        if (currentQuizId === content.id) {
          this.$store.dispatch('content/setCurrentQuizId', '')
        } else {
          this.$store.dispatch('content/setCurrentQuizId', content.id)
          this.$emit('toggle-content', CONSTANTS.CONTENT_TYPES.QUIZ)
        }
        this.isLoading = false
      }
    },
    hasCompleted() {
      if (!this.hasAccess) return '#3A3A3A'
      return this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
        ? '#00DEA0'
        : '#808080'
    },
    setLoader(state) {
      this.isLoading = state
    },
    isTakingQuiz() {
      if (this.content) {
        return this.content.id === this.currentQuizId
      }
      return false
    },
  },
}
</script>
